import { useEffect, useRef } from 'react';
import { stripQuickFilter } from './tableViewFilterUtils';

export default function useInitialServerFilterSync({
  effectiveFilterModel,
  parentFilterModel,
  serverSideFiltering,
  setFilterModel,
  settingsLoading,
  tableKey,
}) {
  const hasAppliedPersistedFilterRef = useRef(false);

  useEffect(() => {
    if (hasAppliedPersistedFilterRef.current) return;
    if (settingsLoading) return;
    if (!serverSideFiltering) return;
    if (!tableKey) return;
    if (!effectiveFilterModel) {
      hasAppliedPersistedFilterRef.current = true;
      return;
    }

    const differsFromParent =
      JSON.stringify(stripQuickFilter(effectiveFilterModel)) !==
      JSON.stringify(stripQuickFilter(parentFilterModel));

    if (differsFromParent) {
      setFilterModel(effectiveFilterModel);
    }
    hasAppliedPersistedFilterRef.current = true;
  }, [
    effectiveFilterModel,
    parentFilterModel,
    serverSideFiltering,
    setFilterModel,
    settingsLoading,
    tableKey,
  ]);
}
